/* eslint-disable import/prefer-default-export */

export const fetchImage = async (imageUrl: string): Promise<File> => {
  // TODO: разобраться с CORS Amazon'а
  const result = await fetch(imageUrl)
  const blob = await result.blob()
  const fileName = Date.now()
  return new File([blob], `${fileName}.jpg`, { type: blob.type })
}
